// User Headers
export const userColumnsHeaders = [
  { field: 'name', headerName: 'Name', width: 250, sortable: true },
  {
    field: 'total_groups',
    headerName: 'Groups',
    width: 150,
    sortable: true
  },
  {
    field: 'last_signin',
    headerName: 'Last Sign In',
    width: 150,
    sortable: true
  },
  {
    field: 'active',
    headerName: 'Status',
    width: 150,
    sortable: true,
    isToggle: true
  }
]

// Contact Headers
export const contactColumnsHeaders = [
  { field: 'name', headerName: 'Name', width: 150, sortable: true },
  { field: 'job_title', headerName: 'Job Title', width: 150, sortable: true },
  {
    field: 'type',
    headerName: 'Person Type',
    width: 150,
    sortable: true
  },
  { field: 'email', headerName: 'Email', width: 150, sortable: true },
  { field: 'phone', headerName: 'Phone', width: 150, sortable: true },
  {
    field: 'total_contracts',
    headerName: 'Accounts',
    width: 150,
    sortable: true
  },
  {
    field: 'total_skillsets',
    headerName: 'Skill Sets',
    width: 150,
    sortable: true
  },
  {
    field: 'total_assets',
    headerName: 'Locations',
    width: 150,
    sortable: true
  }
]
